<a routerLink="/home"
   class="link-button"
   data-test="back-button"><i class="fal fa-chevron-left"></i> Back</a>
<h1>Current Meeting</h1>
<p>This shows the Lumia meeting currently associated with this Outlook meeting.</p>
@if (meeting) {
    <div class="container">
        <h3>Meeting Name: {{ meeting.Name }}</h3>
        @if (meeting.MeetingAgendaItems?.length) {
            <div class="meeting-agenda-items">
                <h4>Agenda</h4>
                <ul>
                    @for (meetingAgendaItem of meeting.MeetingAgendaItems; track meetingAgendaItem) {
                        <li>{{ meetingAgendaItem.Name }}</li>
                    }
                </ul>
            </div>
        }
        <div class="mt-2">
            <a [href]="meetingLink"
               target="_blank"
               data-test="current-meeting-link"><i class="fal fa-external-link-alt"></i> Lumia meeting link</a>
        </div>
        <button class="d-block mt-2"
                [adaptLoading]="sending"
                [adaptLoadingDisabled]="sending || fetching"
                (click)="updateMeeting()"><i class="fal fa-cloud-upload-alt"></i> Update Lumia Meeting</button>
    </div>
}

@if (fetching) {
    <p [adaptLoading]="fetching">Loading...</p>
}

<adapt-message-box [status]="status"
                   [message]="message"></adapt-message-box>
